import { PlanCell, PlanCellCoordinatesWithOptionalPerson } from "../data/plan";
import { MealSourceIdDto } from "../api";
import { createMealFromEntity } from "../api";

export type CreateMealRequest = {
  planCellCoordinates: PlanCellCoordinatesWithOptionalPerson;
  mealSourceId: MealSourceIdDto;
  /** Aktive Gruppe; begrenzt "für alle" auf deren Mitglieder. */
  groupId?: number;
};

export async function createPlanCells(
  requestObj: CreateMealRequest,
): Promise<PlanCell[]> {
  const mealsWithIngredients = (await createMealFromEntity({ body: requestObj }))
    .data;
  return mealsWithIngredients.map((mealWithIngredients) => {
    return {
      indicator: "MealWithIntakes",
      meal: mealWithIngredients,
    };
  });
}
